/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import Loader from "../../../component/loader";
import { connect } from "react-redux";
import HeaderNoAuth from "../../../component/header/headerNoAuth";
import actionTypes from "../../../store/actions";
import classes from "../apiPortal/apiPortal.module.css";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import classes2 from "../documentation/documentation.module.css";
import Route from "../../../auth/route";

class ApiReadOnly extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {}

  render() {
    return (
      <React.Fragment>
        <HeaderNoAuth />
        <main style={{ maxWidth: "initial" }}>
          <Grid container>
            <Grid
              item
              size={{
                xs: 2,
                md: 1,
              }}
            >
              <ul className={classes.leftNavigation}>
                <li>
                  {" "}
                  <Link to="/api-portal"> API Portal </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link className={classes.selected} to="/api-read-only">
                    {" "}
                    API Reference{" "}
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/registration"> Developer Registration </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/sdk"> API SDKs </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/api-ref"> Try Out API </Link>{" "}
                </li>
                {/*<li> <Link to='/internal-api'> Internal API </Link> </li>*/}
              </ul>
            </Grid>
            <Grid
              item
              size={{
                xs: 1,
                md: 1,
              }}
            ></Grid>
            <Grid
              item
              size={{
                xs: 9,
                md: 10,
              }}
            >
              <h1 className={classes2.heading}>
                API References - Browse APIs{" "}
              </h1>

              <div>
                <SwaggerUI
                  url="/public_readonly_api_v4.4.yaml"
                  docExpansion="list"
                  supportedSubmitMethods="[]"
                  defaultModelsExpandDepth={-1}
                />
              </div>
            </Grid>
          </Grid>
          <Loader loading={this.state.loading} />
        </main>
      </React.Fragment>
    );
  }
}

const DisableTryItOutPlugin = function () {
  return {
    statePlugins: {
      spec: {
        wrapSelectors: {
          allowTryItOutFor: () => () => false,
        },
      },
    },
  };
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApiReadOnly);
